const rewards = [
    {
        "id": 1,
        "name": "七彩盾菇",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037245212.png"
    },
    {
        "id": 2,
        "name": "金币",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037172588.png"
    },
    {
        "id": 3,
        "name": "法塔能量",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037157424.png"
    },
    {
        "id": 4,
        "name": "命运钱币",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037225317.png"
    },
    {
        "id": 5,
        "name": "能量",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037234394.png"
    },
    {
        "id": 6,
        "name": "水晶",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037255694.png"
    },
    {
        "id": 7,
        "name": "材料兑换券",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037345050.png"
    },
    {
        "id": 8,
        "name": "召唤卷轴",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037309604.png"
    },
    {
        "id": 9,
        "name": "体力药剂",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037267544.png"
    },
    {
        "id": 10,
        "name": "觉醒券",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037207876.png"
    },
    {
        "id": 11,
        "name": "团团·命",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037289633.png"
    },
    {
        "id": 12,
        "name": "团团·剑",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037283217.png"
    },
    {
        "id": 13,
        "name": "团团·愈",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037335043.png"
    },
    {
        "id": 14,
        "name": "团团·盾",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037276816.png"
    },
    {
        "id": 15,
        "name": "友爱之心",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037304569.png"
    },
    {
        "id": 16,
        "name": "精铁剑",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037176111.png"
    },
    {
        "id": 17,
        "name": "秘银匕首",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037346735.png"
    },
    {
        "id": 18,
        "name": "藏宝图",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037325552.png"
    },
    {
        "id": 19,
        "name": "宝石权杖",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037156943.png"
    },
    {
        "id": 20,
        "name": "精准指环",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037316378.png"
    },
    {
        "id": 21,
        "name": "十字架",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037257013.png"
    },
    {
        "id": 22,
        "name": "魔法日记",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037229801.png"
    },
    {
        "id": 23,
        "name": "庇护之心",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037362019.png"
    },
    {
        "id": 24,
        "name": "旅行者背包",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037328295.png"
    },
    {
        "id": 25,
        "name": "异界见闻录",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037357026.png"
    },
    {
        "id": 26,
        "name": "烤肉",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037215715.png"
    },
    {
        "id": 27,
        "name": "机枪模型",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037184623.png"
    },
    {
        "id": 28,
        "name": "麦克风",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037362860.png"
    },
    {
        "id": 29,
        "name": "樱花水信玄饼",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037298322.png"
    },
    {
        "id": 30,
        "name": "草莓",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037279700.png"
    },
    {
        "id": 31,
        "name": "IFC套餐",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037166080.png"
    },
    {
        "id": 32,
        "name": "零食礼盒",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037215572.png"
    },
    {
        "id": 33,
        "name": "酒",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037192265.png"
    },
    {
        "id": 34,
        "name": "圣典",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037244746.png"
    },
    {
        "id": 35,
        "name": "钻石",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037317216.png"
    },
    {
        "id": 36,
        "name": "羁绊契约",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037193348.png"
    },
    {
        "id": 37,
        "name": "天使之翼",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037266364.png"
    },
    {
        "id": 38,
        "name": "恶魔之翼",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037207949.png"
    },
    {
        "id": 39,
        "name": "黑函",
        "img": "https://fu5.web.sdo.com/10046/202212/16703037168422.png"
    },
    {
        "id": 40,
        "name": "食蜂操祈手办",
        "img": "https://fu5.web.sdo.com/10046/202212/16703138522355.png"
    },
    {
        "id": 41,
        "name": "御坂美琴手办",
        "img": "https://fu5.web.sdo.com/10046/202212/16703117893500.png"
    },
    {
        "id": 42,
        "name": "夜愿礼赞套装",
        "img": "https://fu5.web.sdo.com/10046/202212/16703130442079.png"
    }
]
const roles = [
    {
        "id": 1,
        "name": "食蜂操祈",
        "desc": "你交谈间的真诚让她十分满意，于是收获一份回礼",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070123307.png"
    },
    {
        "id": 2,
        "name": "上条当麻",
        "desc": "为了得到你手中的促销宣传单，他拿出穿越位面时捡到的",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070116236.png"
    },
    {
        "id": 3,
        "name": "芙兰达",
        "desc": "她正为买不到鲭鱼罐头而苦恼，手脚发抖之时掉落出",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070169613.png"
    },
    {
        "id": 4,
        "name": "御坂妹妹",
        "desc": "停在这里绝不是因为身体疲惫，御坂拿出东西解释道",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070511572.png"
    },
    {
        "id": 5,
        "name": "警策看取",
        "desc": "你分享了各方势力的重要能力，她基于这份情报给了你",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070127655.png"
    },
    {
        "id": 6,
        "name": "御坂美琴",
        "desc": "你不小心被她释放的电流麻痹，清醒后发现身边多了",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070114828.png"
    },
    {
        "id": 7,
        "name": "婚后光子",
        "desc": "你隔着扇子认出了大小姐身份，凭借眼力劲而获得奖赏",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070158712.png"
    },
    {
        "id": 8,
        "name": "白井黑子",
        "desc": "你因行动浮夸而即将被她抓捕，逃跑期间意外拾到",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070149164.png"
    },
    {
        "id": 9,
        "name": "战争姬",
        "desc": "被圣地第一战力的气势所震慑，跪下行礼时却看到了",
        "img": "https://fu5.web.sdo.com/10046/202212/16704701927458.png"
    },
    {
        "id": 10,
        "name": "灵儿",
        "desc": "差点被她当作大型生物清理掉，为了表达歉意送给你",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070093810.png"
    },
    {
        "id": 11,
        "name": "绫叁",
        "desc": "你协助她完成了异端扫除任务，并捡到敌人守护的",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070075450.png"
    },
    {
        "id": 12,
        "name": "莉萝艾",
        "desc": "你献祭全身鲜血希望换来暴富，万万没想到竟得到",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070085465.png"
    },
    {
        "id": 13,
        "name": "夜刃",
        "desc": "他看到了你手机里的吟唱咒语，于是提出等价置换",
        "img": "https://fu5.web.sdo.com/10046/202212/16704703098353.png"
    },
    {
        "id": 14,
        "name": "夜莱",
        "desc": "交谈中她得知你是夜刃的好友，高兴地送上一份见面礼",
        "img": "https://fu5.web.sdo.com/10046/202212/16704703529506.png"
    },
    {
        "id": 15,
        "name": "露露缇雅",
        "desc": "你通过彩虹屁获得女神签名照，马上转手卖出得到了",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070107113.png"
    },
    {
        "id": 16,
        "name": "毁灭隆音",
        "desc": "你在餐食中加入了科技与狠活，趁他吃完犯困时顺走了",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070094245.png"
    },
    {
        "id": 17,
        "name": "拉斯特",
        "desc": "你绘声绘色讲述莉萝艾的趣事，逗的他哈哈大笑并获得",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070137249.png"
    },
    {
        "id": 18,
        "name": "雷克斯",
        "desc": "你被艺术家的优雅气质所感染，答应做人体模特赚取",
        "img": "https://fu5.web.sdo.com/10046/202212/16704070085139.png"
    },
    {
        "id": 19,
        "name": "西利欧",
        "desc": "他请你帮忙代购达冈同款女装，提前支付了一些酬劳",
        "img": "https://fu5.web.sdo.com/10046/202212/16704705036454.png"
    }
]

const friends=[
    {
        id:1,
        roles:[15,16,17],
        rewardid:48,
        content:"钻石×1000"
    },
    {
        id:2,
        roles:[1,2,4],
        rewardid:49,
        content:"黑函×10"
    },
    {
        id:3,
        roles:[6,8,7],
        rewardid:50,
        content:"羁绊契约×10"
    },
    {
        id:4,
        roles:[12,13,14],
        rewardid:51,
        content:"天使之翼×5"
    },
    {
        id:5,
        roles:[9,10,11],
        rewardid:52,
        content:"恶魔之翼×5"
    }
];

export { rewards,roles,friends}